/* ========
   Zayne Paris — Barre de progression du panier
   <cart-rewards> : progression vers la livraison offerte puis le tote bag.
   <cart-upsell>  : vente complémentaire compacte sous les articles.
   <cart-discount-form> : saisie / remplacement / retrait du code promo.
   Recalcule la barre sans rechargement, et rafraîchit le tiroir quand
   free-gift.js ajoute ou retire le tote bag.
   ======== */
(function () {
  'use strict';

  var CHECK_SVG =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="m4 12.5 5 5L20 6.5" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function money(cents) {
    if (typeof window.formatMoney === 'function') {
      try {
        return window.formatMoney(cents);
      } catch (e) {
        /* on retombe sur Intl */
      }
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* -------- Rafraîchissement tiroir */

  function refreshCartDrawer() {
    var base = root() + 'cart';
    return Promise.all([
      fetch(base + '?section_id=cart-drawer').then(function (r) {
        return r.text();
      }),
      fetch(base + '?section_id=cart-icon-bubble').then(function (r) {
        return r.text();
      })
    ])
      .then(function (results) {
        var parser = new DOMParser();
        var drawer = document.querySelector('cart-drawer');

        var drawerDoc = parser.parseFromString(results[0], 'text/html');
        var sourceRoot = drawerDoc.querySelector('cart-drawer');
        var sourceInner = drawerDoc.querySelector('.cart-drawer__inner');
        if (drawer && sourceInner) {
          var inner = drawer.querySelector('.cart-drawer__inner');
          if (inner) inner.innerHTML = sourceInner.innerHTML;
          if (sourceRoot) {
            drawer.classList.toggle('is-empty', sourceRoot.classList.contains('is-empty'));
          }
        }

        var bubbleDoc = parser.parseFromString(results[1], 'text/html');
        var bubbleEl = document.getElementById('cart-icon-bubble');
        var bubbleSrc = bubbleDoc.querySelector('.shopify-section');
        if (bubbleEl && bubbleSrc) {
          var target = bubbleEl.querySelector('.shopify-section') || bubbleEl;
          target.innerHTML = bubbleSrc.innerHTML;
        }

        if (drawer && typeof window.setHasScrollClass === 'function') {
          window.setHasScrollClass(drawer.querySelector('cart-drawer-items'));
        }
        return drawer;
      })
      .catch(function (error) {
        console.error('[zayne-cart] rafraîchissement du panier impossible :', error);
      });
  }

  window.zayneRefreshCartDrawer = refreshCartDrawer;

  /* Après un changement de code promo : sur les pages qui ont le tiroir on le
     re-rend, sur la page panier (pas de tiroir) on recharge pour que les
     totaux et la barre soient justes. */
  function refreshAfterDiscount() {
    if (!document.querySelector('cart-drawer')) {
      window.location.reload();
      return Promise.resolve();
    }
    return refreshCartDrawer();
  }

  /* -------- Barre de récompenses */

  var lastProgress = null;

  class CartRewards extends HTMLElement {
    connectedCallback() {
      this.update();
    }

    update() {
      var rate = parseFloat(
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1
      );
      if (!rate || isNaN(rate)) rate = 1;

      var total = parseInt(this.dataset.total, 10) || 0;

      var tiers = [];
      try {
        tiers = JSON.parse(this.dataset.tiers || '[]');
      } catch (e) {
        tiers = [];
      }
      if (!tiers.length) return;

      tiers = tiers
        .map(function (tier) {
          return { amount: Math.round(tier.amount * rate), label: tier.label, phrase: tier.phrase };
        })
        .sort(function (a, b) {
          return a.amount - b.amount;
        });

      // Les jalons sont espacés régulièrement (et non proportionnellement au
      // montant) : avec 69 € et 80 € ils se chevaucheraient sinon. Le
      // remplissage est donc calculé segment par segment.
      var count = tiers.length;
      var step = 100 / count;

      var next = null;
      var progress = 100;
      for (var i = 0; i < count; i++) {
        if (total < tiers[i].amount) {
          next = tiers[i];
          var previous = i === 0 ? 0 : tiers[i - 1].amount;
          var span = tiers[i].amount - previous;
          var ratio = span > 0 ? (total - previous) / span : 0;
          progress = i * step + Math.max(0, Math.min(ratio, 1)) * step;
          break;
        }
      }

      var nodes = this.querySelectorAll('[data-rewards-tier]');
      Array.prototype.forEach.call(nodes, function (node, index) {
        var tier = tiers[index];
        if (!tier) return;
        node.classList.toggle('is-unlocked', total >= tier.amount);

        // À taux 1, le Liquid a déjà écrit « dès 69 € » (sans décimales) :
        // on ne réécrit qu'en multi-devise, où la conversion est nécessaire.
        if (rate !== 1) {
          var amountEl = node.querySelector('[data-rewards-amount]');
          if (amountEl) amountEl.innerHTML = money(tier.amount);
        }

        var labelEl = node.querySelector('[data-rewards-label]');
        if (labelEl) labelEl.textContent = tier.label;

        node.style.left = (index + 1) * step + '%';
      });

      var message = this.querySelector('[data-rewards-message]');
      if (message) {
        if (next) {
          message.className = 'cart-rewards__message body-small';
          message.innerHTML = escapeHtml(this.dataset.progressTemplate || '')
            .replace('[amount]', '<strong>' + money(next.amount - total) + '</strong>')
            .replace('[reward]', escapeHtml(next.phrase || next.label));
        } else {
          message.className = 'cart-rewards__message cart-rewards__message--success body-small';
          message.innerHTML =
            CHECK_SVG + '<span>' + escapeHtml(this.dataset.successTemplate || '') + '</span>';
        }
      }

      var fill = this.querySelector('[data-rewards-fill]');
      if (fill) {
        if (lastProgress !== null && Math.abs(lastProgress - progress) > 0.01) {
          fill.style.width = lastProgress + '%';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              fill.style.width = progress + '%';
            });
          });
        } else {
          fill.style.width = progress + '%';
        }
        lastProgress = progress;
      }
    }
  }

  if (!customElements.get('cart-rewards')) {
    customElements.define('cart-rewards', CartRewards);
  }

  /* -------- Vente complémentaire */

  /* Cache par URL + état du panier : évite de rejouer la requête quand le
     tiroir est rouvert sans changement, tout en garantissant qu'une liste
     calculée pour un panier plus court n'est jamais réutilisée — elle
     contiendrait un produit qui vient d'y être ajouté. */
  var upsellCache = {};

  function fetchUpsell(url, key) {
    var cacheKey = url + '#' + (key || '');
    if (!upsellCache[cacheKey]) {
      upsellCache[cacheKey] = fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var inner = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.cart-upsell__inner');
          return inner ? inner.outerHTML : '';
        })
        .catch(function (error) {
          console.error('[zayne-cart] recommandations indisponibles :', error);
          delete upsellCache[cacheKey];
          return '';
        });
    }
    return upsellCache[cacheKey];
  }

  class CartUpsell extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url) return;
      var self = this;
      fetchUpsell(url, this.dataset.cartKey).then(function (html) {
        self.innerHTML = html;
        self.bind();
      });
    }

    bind() {
      var self = this;

      // « + » d'un produit décliné : déplie la liste des tailles
      Array.prototype.forEach.call(this.querySelectorAll('[data-upsell-toggle]'), function (button) {
        button.addEventListener('click', function () {
          var card = button.closest('.cart-upsell__card');
          var sizes = card && card.querySelector('[data-upsell-sizes]');
          if (!sizes) return;
          var open = !sizes.hasAttribute('hidden');
          if (open) sizes.setAttribute('hidden', '');
          else sizes.removeAttribute('hidden');
          button.setAttribute('aria-expanded', open ? 'false' : 'true');
          card.classList.toggle('is-choosing', !open);
        });
      });

      Array.prototype.forEach.call(this.querySelectorAll('[data-upsell-add]'), function (button) {
        button.addEventListener('click', function () {
          self.addToCart(button);
        });
      });

      // Indicateur de défilement : fine ligne centrée sous le carrousel
      var list = this.querySelector('[data-upsell-list]');
      var bar = this.querySelector('[data-upsell-scrollbar]');
      var thumb = this.querySelector('[data-upsell-scrollbar-thumb]');
      if (list && bar && thumb) {
        var updateScrollbar = function () {
          var max = list.scrollWidth - list.clientWidth;
          if (max <= 1) {
            bar.setAttribute('hidden', '');
            return;
          }
          bar.removeAttribute('hidden');
          var width = (list.clientWidth / list.scrollWidth) * 100;
          var left = (list.scrollLeft / list.scrollWidth) * 100;
          thumb.style.width = width + '%';
          thumb.style.left = left + '%';
        };
        list.addEventListener('scroll', updateScrollbar, { passive: true });
        window.addEventListener('resize', updateScrollbar);
        // Le contenu est souvent injecté tiroir FERMÉ : toutes les largeurs
        // valent alors 0 et l'indicateur resterait caché. On remesure dès que
        // la liste prend sa taille réelle, c'est-à-dire à l'ouverture.
        if ('ResizeObserver' in window) {
          new ResizeObserver(updateScrollbar).observe(list);
        }
        updateScrollbar();

        // Le trait sert aussi de vraie barre : glisser le segment, ou
        // cliquer sur la ligne pour sauter à cet endroit du carrousel.
        var sbDrag = { active: false, x: 0, from: 0 };

        bar.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          var max = list.scrollWidth - list.clientWidth;
          if (max <= 0) return;
          event.preventDefault();
          var rect = bar.getBoundingClientRect();
          var thumbRect = thumb.getBoundingClientRect();
          if (event.clientX < thumbRect.left || event.clientX > thumbRect.right) {
            // clic hors du segment : on centre le segment sur le point cliqué
            var course = rect.width - thumbRect.width;
            if (course > 0) {
              var ratio = (event.clientX - rect.left - thumbRect.width / 2) / course;
              list.scrollLeft = Math.max(0, Math.min(1, ratio)) * max;
            }
          }
          sbDrag.active = true;
          sbDrag.x = event.clientX;
          sbDrag.from = list.scrollLeft;
          bar.classList.add('is-dragging');
          // coupe l'aimantation le temps du geste, comme pour le glisser direct
          list.classList.add('is-dragging');
          try {
            bar.setPointerCapture(event.pointerId);
          } catch (e) {
            /* sans capture, le glisser marche tant que le curseur reste dessus */
          }
        });

        bar.addEventListener('pointermove', function (event) {
          if (!sbDrag.active) return;
          var max = list.scrollWidth - list.clientWidth;
          var course = bar.getBoundingClientRect().width - thumb.getBoundingClientRect().width;
          if (max <= 0 || course <= 0) return;
          list.scrollLeft = sbDrag.from + ((event.clientX - sbDrag.x) / course) * max;
        });

        var endBarDrag = function () {
          if (!sbDrag.active) return;
          sbDrag.active = false;
          bar.classList.remove('is-dragging');
          list.classList.remove('is-dragging');
        };
        bar.addEventListener('pointerup', endBarDrag);
        bar.addEventListener('pointercancel', endBarDrag);

        // La barre native étant masquée, la souris a son propre geste :
        // cliquer-glisser directement sur le carrousel.
        var drag = { active: false, captured: false, moved: false, x: 0, from: 0 };

        list.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });

        list.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          drag.active = true;
          drag.captured = false;
          drag.moved = false;
          drag.x = event.clientX;
          drag.from = list.scrollLeft;
        });

        list.addEventListener('pointermove', function (event) {
          if (!drag.active) return;
          var dx = event.clientX - drag.x;
          if (!drag.captured && Math.abs(dx) > 5) {
            drag.captured = true;
            drag.moved = true;
            list.classList.add('is-dragging');
            try {
              list.setPointerCapture(event.pointerId);
            } catch (e) {
              /* sans capture, le glisser marche tant que le curseur reste dessus */
            }
          }
          if (drag.captured) list.scrollLeft = drag.from - dx;
        });

        var endDrag = function () {
          if (!drag.active) return;
          drag.active = false;
          drag.captured = false;
          list.classList.remove('is-dragging');
        };
        list.addEventListener('pointerup', endDrag);
        list.addEventListener('pointercancel', endDrag);

        // Un glisser ne doit pas déclencher le clic du produit au relâcher
        list.addEventListener(
          'click',
          function (event) {
            if (!drag.moved) return;
            drag.moved = false;
            event.preventDefault();
            event.stopPropagation();
          },
          true
        );

      }
    }

    addToCart(button) {
      var variantId = button.dataset.variantId;
      if (!variantId || button.disabled) return;

      button.disabled = true;
      button.classList.add('is-busy');

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add.js ' + response.status);
          return response.json();
        })
        .then(function () {
          // le panier a changé : la liste des recommandations exclut ce qui y
          // est déjà, elle n'est plus valable
          upsellCache = {};
          return refreshCartDrawer();
        })
        .then(function () {
          if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'zayne-upsell' });
          }
        })
        .catch(function (error) {
          console.error('[zayne-cart] ajout impossible :', error);
          button.disabled = false;
          button.classList.remove('is-busy');
        });
    }
  }

  if (!customElements.get('cart-upsell')) {
    customElements.define('cart-upsell', CartUpsell);
  }

  /* -------- Code promo */

  class CartDiscountForm extends HTMLElement {
    connectedCallback() {
      var self = this;

      var apply = this.querySelector('[data-discount-apply]');
      if (apply) {
        apply.addEventListener('click', function () {
          self.submit();
        });
      }

      var remove = this.querySelector('[data-discount-remove]');
      if (remove) {
        remove.addEventListener('click', function () {
          self.send('', remove);
        });
      }

      var input = this.querySelector('[data-discount-input]');
      if (input) {
        input.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') return;
          // le champ est dans le <form> du panier : sans ça, Entrée déclenche
          // le paiement
          event.preventDefault();
          self.submit();
        });
      }
    }

    message(text) {
      var el = this.querySelector('[data-discount-message]');
      if (el) el.textContent = text || '';
    }

    busy(button, state) {
      Array.prototype.forEach.call(this.querySelectorAll('button, input'), function (el) {
        el.disabled = state;
      });
      if (button) button.classList.toggle('is-busy', state);
    }

    /* /cart/update.js accepte `discount` depuis 2025 : une chaîne vide retire
       tous les codes, une valeur remplace ceux en place. */
    post(code) {
      return fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(function (response) {
        if (!response.ok) throw new Error('update.js ' + response.status);
        return response.json();
      });
    }

    send(code, button) {
      var self = this;
      this.message('');
      this.busy(button, true);

      return this.post(code)
        .then(function () {
          return refreshAfterDiscount();
        })
        .then(function () {
          if (
            typeof window.publish === 'function' &&
            typeof window.PUB_SUB_EVENTS !== 'undefined'
          ) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'zayne-discount' });
          }
        })
        .catch(function (error) {
          console.error('[zayne-cart] code promo :', error);
          self.message(self.dataset.error || '');
          self.busy(button, false);
        });
    }

    submit() {
      var input = this.querySelector('[data-discount-input]');
      var button = this.querySelector('[data-discount-apply]');
      var code = input ? (input.value || '').trim() : '';
      if (!code) return;

      var self = this;
      var previous = this.dataset.applied || '';

      this.message('');
      this.busy(button, true);

      return this.post(code)
        .then(function (cart) {
          var codes = cart.discount_codes || [];
          var ok = codes.some(function (entry) {
            return entry.applicable && String(entry.code).toLowerCase() === code.toLowerCase();
          });

          if (ok) {
            return refreshAfterDiscount().then(function () {
              if (
                typeof window.publish === 'function' &&
                typeof window.PUB_SUB_EVENTS !== 'undefined'
              ) {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'zayne-discount' });
              }
            });
          }

          // code refusé : on ne laisse pas un code mort dans le panier,
          // on rétablit celui d'avant
          return self.post(previous).then(function () {
            self.message(self.dataset.error || '');
            self.busy(button, false);
          });
        })
        .catch(function (error) {
          console.error('[zayne-cart] code promo :', error);
          self.message(self.dataset.error || '');
          self.busy(button, false);
        });
    }
  }

  if (!customElements.get('cart-discount-form')) {
    customElements.define('cart-discount-form', CartDiscountForm);
  }

  /* -------- Synchro avec le cadeau automatique */

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.subscribe === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event) return;
        upsellCache = {};
        if (event.source === 'free-gift') {
          // free-gift.js ajoute ou retire le tote bag sans re-rendre le
          // tiroir : on s'en charge pour que la barre suive
          refreshCartDrawer();
        }
      });
    }
  });
})();
